import { render, staticRenderFns } from "./Colaboradores.vue?vue&type=template&id=88268c76"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"
import style0 from "./Colaboradores.vue?vue&type=style&index=0&id=88268c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports